if (!customElements.get("addon-bundler")) {
class AddonBundler extends HTMLElement {
  constructor() {
    super();
    // 绑定 this，确保事件处理函数中能访问到组件实例
    // this.handleInteraction = this.handleInteraction.bind(this);
    this.handleVariantClick = this.handleVariantClick.bind(this);
  }

  connectedCallback() {
    // 使用 setTimeout 确保子元素（Light DOM）已解析
    requestAnimationFrame(() => {
      this.init();
    });
  }

  init() {
    // 1. 缓存关键元素
    // 注意：Payment Button 可能在组件内部，也可能在外部，这里做个兼容
    this.paymentButton = this.querySelector('.shopify-payment-button') || document.querySelector('.shopify-payment-button');
    this.mainProduct = this.querySelector('#addons-main-product-data'); // 假设主产品 input 在组件外或内都能找到
    this.mainProductQty = null
    if(this.mainProduct) {
        this.mainProductQty = document.getElementById(`quantity-${this.mainProduct.dataset.section}`)
    }
    if(this.mainProductQty) this.mainProductQty.addEventListener('change', this.handleQuantityChange)
    // 2. 初始化状态
    const checkboxes = this.querySelectorAll('.poi-checkbox');
    checkboxes.forEach(box => box.disabled = false);

    // 3. 绑定事件 (使用事件委托优化性能)
    // 监听 Checkbox 变化
    this.addEventListener('change', (e) => {
      if (e.target.classList.contains('poi-checkbox')) {
        this.handleCheckboxChange(e.target);
        this.dispatchBundleUpdate();
        this.togglePaymentButton();
      }
    });
    this.freeGiftContainer = document.querySelector('.free-gift-container') || document.querySelector('.free-gift-inputs')
    if(this.freeGiftContainer) {
      this.freeGiftContainer.addEventListener('change', (e) =>{
        if(e.target.classList.contains('poi-checkbox')) {
          this.dispatchBundleUpdate();
        }
      })
    }

    // 监听变体 Option 点击 (因为是 div/span 点击，不是 change 事件)
    // 我们可以直接监听组件的 click，然后判断 target
    this.addEventListener('click', (e) => {
      const option = e.target.closest('.poiv-option');
      if (option) {
        this.handleVariantClick(e, option);
      }
    });
    // 注意：这里监听的是 document，因为事件是由外部 JS 触发的
    document.addEventListener('product:variant-change', this.handleGlobalVariantChange);

    // 4. 初始运行一次
    this.dispatchBundleUpdate();
    this.togglePaymentButton();
  }

  // --- 逻辑处理部分 ---
    // 处理主产品变体切换 ---
  handleGlobalVariantChange = (e) => {
    // 安全检查：确保有变体数据且主产品 input 存在
    const variant = e.detail.variant;
    
    if (!variant.available || !this.mainProduct) return;
    // 1. 更新主产品 hidden input 的数据
    let variantMetaData = this.getVariantMetaData()
    if(variantMetaData[variant.id] && variantMetaData[variant.id].off) {
        this.mainProduct.dataset.variantOff = variantMetaData[variant.id].off
    }else {
        this.mainProduct.dataset.variantOff = this.mainProduct.dataset.off
    }
    this.mainProduct.dataset.variantTitle = variant.title
    
    this.mainProduct.value = variant.id;
    // Shopify 事件里的 price 通常是“分” (2999)，直接存进去
    this.mainProduct.dataset.price = variant.price; 
    this.mainProduct.dataset.comparePrice = variant.compare_at_price; 
    this.mainProduct.dataset.featuredImage = variant.featured_image ? this.addSizeToImageUrl(variant.featured_image.src) : this.mainProduct.dataset.featuredImage;
    // 2. 立即触发总价重新计算
    this.dispatchBundleUpdate(false);
  }
  addSizeToImageUrl(url, size = '_128x') {
    if (!url || typeof url !== 'string') return url;
    
    // 匹配常见图片格式扩展名
    return url.replace(/\.(png|jpg|jpeg|gif|webp|bmp|svg)(?=\?|$)/i, `${size}.$1`);
  }
  //   主产品quantity change
  handleQuantityChange = () => {
    this.dispatchBundleUpdate()
  }
  handleCheckboxChange(checkbox) {
    const parent = checkbox.closest('.poi-label');
    const variantsContainer = parent.querySelector('.poiv-variants');

    if (checkbox.checked) {
      parent.classList.add('checked');
      if (variantsContainer) variantsContainer.classList.add('checked');
    } else {
      parent.classList.remove('checked');
      if (variantsContainer) variantsContainer.classList.remove('checked');
    }
  }
  handleVariantClick(e, option) {
    e.stopPropagation(); // 阻止冒泡，视情况而定
    
    const parent = option.closest('.poi-label');
    const checkbox = parent.querySelector('.poi-checkbox');
    
    // 如果已经激活且已勾选，不做操作
    if (option.classList.contains('active') && checkbox.checked) return;

    // UI 切换
    parent.querySelectorAll('.poiv-option').forEach(o => o.classList.remove('active'));
    option.classList.add('active');

    // 数据同步
    const variantId = option.dataset.variantId;
    parent.dataset.variantId = variantId;
    checkbox.dataset.variantId = variantId;

    // 自动勾选逻辑
    if (!checkbox.checked) {
      checkbox.checked = true;
      // 手动触发 UI 更新逻辑
      this.handleCheckboxChange(checkbox);
    }

    // 广播更新
    this.dispatchBundleUpdate();
    this.togglePaymentButton();
  }

  togglePaymentButton() {
    const hasChecked = Array.from(this.querySelectorAll('.poi-checkbox')).some(item => item.checked);
    if (this.paymentButton) {
      this.paymentButton.style.display = hasChecked ? 'none' : 'block';
    }
  }

  // --- 核心：广播事件 ---
  dispatchBundleUpdate(qtyChange = true) {
    const selectedItems = [];
    let totalPrice = 0;
    let totalComparePrice = 0;

    // A. 获取主产品
    if (this.mainProduct) {
      const price = parseFloat(this.mainProduct.dataset.price);
      const off =  parseFloat(this.mainProduct.dataset.variantOff) * 100 || parseFloat(this.mainProduct.dataset.off) * 100 || 0
      let mainQty = 1
      // if(this.mainProductQty) mainQty = parseInt(this.mainProductQty.value) || 1;
      if(this.mainProductQty) {
        let qtyIpt = this.mainProductQty.querySelector('input')
        if(qtyIpt) mainQty = qtyChange ? parseInt(qtyIpt.value) || 1 : 1
      }
      const comparePrice = parseFloat(this.mainProduct.dataset.comparePrice) || price;
      selectedItems.push({
        id: this.mainProduct.value,
        variantTitle: this.mainProduct.dataset.variantTitle,
        featuredImage: this.mainProduct.dataset.featuredImage,
        price: price - off,
        quantity: mainQty,
        comparePrice,
        title: this.mainProduct.dataset.havebundle ? document.querySelector('bundle-variant-picker input:checked')?.value.split(')')[0] : this.mainProduct.dataset.title
      });
      totalPrice += price * mainQty;
      totalPrice -= off * mainQty;
      totalComparePrice += comparePrice * mainQty;
    }

    // B. 获取配件
    const checkboxes = this.querySelectorAll('.poi-checkbox:checked');
    checkboxes.forEach(box => {
      const price = parseFloat(box.dataset.price);
      const comparePrice = parseFloat(box.dataset.comparePrice) || price;
      const card = box.closest('.poi-label');
      const title = card.querySelector('.poiv-title').innerText;

      selectedItems.push({
        id: box.dataset.variantId,
        price,
        comparePrice,
        title
      });
      totalPrice += price;
      totalComparePrice += comparePrice;
    });
    
    // C.获取赠品
    if(this.freeGiftContainer) {
      const freeGifts = this.freeGiftContainer.querySelectorAll('.poi-checkbox:checked');
      freeGifts.forEach(box => {
        const price = 0;
        const comparePrice = 0;
        // const card = box.closest('.poi-label');
        // const title = card.querySelector('.poiv-title').innerText;
        const title = box.dataset.title

        selectedItems.push({
          id: box.dataset.variantId,
          price,
          comparePrice,
          title
        });
      });
    }

    // C. 发送事件 (Event Bus)
    const eventData = {
      items: selectedItems,
      totalCount: selectedItems.length,
      totalPrice,
      totalComparePrice,
      save: totalComparePrice - totalPrice,
    };

    // 派发到 document 上，确保外部任何位置都能监听到
    document.dispatchEvent(new CustomEvent('add-ons:update', {
      detail: eventData,
      bubbles: true
    }));
  }
  getVariantMetaData() {
    try {
        this.variantMetaData = this.variantMetaData || JSON.parse(document.getElementById('variantMetaData').textContent);
        return this.variantMetaData;        
    } catch (error) {
        console.log(error, 'getVariantMetaData');
        return {}
    }
  }
}

// 注册组件
customElements.define('addon-bundler', AddonBundler);
}
